// require('./_row-fullwidth-container');
// require('./_row-fullwidth');
// require('./_scroll');
require('./utils/apis');

$(window).on('load', function() {
    $('main').addClass('init');

    $('.slick').slick({
        dots: false,
        arrows: true,
        useCSS: false,
        useTransform: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fal fa-chevron-left"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="fal fa-chevron-right"></i></button>',
    });
});

$(document).ready(function() {
    $('form input:not(#s)').on('keypress', function(e) {
        return e.which !== 13;
    });
    $('.mxm-form select, .gform_wrapper select').select2({
        // minimumResultsForSearch: Infinity
    });
});

$(window).on('load resize', setMainPadding);

function setMainPadding() {
    $('[data-mainPadding]').css('padding-top', $('header').height());
}
